module.exports = __webpack_public_path__ + "img/asteroid1.59c27254.jpg";